import { render, staticRenderFns } from "./dynamicFiled.vue?vue&type=template&id=38354107&scoped=true"
import script from "./dynamicFiled.vue?vue&type=script&lang=js"
export * from "./dynamicFiled.vue?vue&type=script&lang=js"
import style0 from "./dynamicFiled.vue?vue&type=style&index=0&id=38354107&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38354107",
  null
  
)

export default component.exports